<body class="hold-transition login-page" style="background-color: #343a40;">
